import { generatePath } from 'react-resource-router';

import { boysenberryCodePagePath, boysenberryFlowPath, boysenberryPath } from './paths';

export const getBoysenberryPath = () => {
	return generatePath(boysenberryPath);
};

export const createFlowRoute = (flowId: string) => {
	return generatePath(boysenberryFlowPath, {
		flowId,
	});
};

export const createFlowCodeRoute = (flowId: string) => {
	return generatePath(boysenberryCodePagePath, {
		flowId,
	});
};
